import type { GanttObrasProps } from "./types-gantt-obras";
import { useGanttObras } from "./use-gantt-obras";
import { GanttObrasView } from "./view-gantt-obras";

export function GanttObras(props: GanttObrasProps) {
  const vm = useGanttObras(props);

  return <GanttObrasView {...vm} />;
}

export type * from "./types-gantt-obras";
